import { render } from "./ScrabbleBoard.vue?vue&type=template&id=ef7d9e42&scoped=true"
import script from "./ScrabbleBoard.vue?vue&type=script&lang=js"
export * from "./ScrabbleBoard.vue?vue&type=script&lang=js"

import "./ScrabbleBoard.vue?vue&type=style&index=0&id=ef7d9e42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7d9e42"]])

export default __exports__